import {
  CustomSeriesOption,
  EChartsOption,
  graphic,
  LineSeriesOption,
} from "echarts";
import { generateNumbers } from "@/utils/math";
import Decimal from "decimal.js";

export type PlayStatus = "play" | "pause" | "stop";
export type FunctionStatus = "disable" | "enable" | "active";
const diameter = 0.365 * 2; // 0.365 半径, 单位：米

export function rpmToKph(rpm: number) {
  // 计算周长
  const circumference = Math.PI * diameter;

  // 计算线速度（米/秒）
  const linearSpeed = (circumference * rpm) / 60;

  // 将线速度转换为公里每小时
  const kph = linearSpeed * 3.6;

  return kph;
}

export function parseNegative(data: number) {
  return data < 0 ? 0 : data;
}
export function parseMotTq(data: number) {
  if (data < 0) return 0;
  const value = new Decimal(data);
  return value.times(11.5).toDecimalPlaces(1).toNumber();
}

// 示例使用
// const rpm = 100; // 每分钟转数
// const diameter = 0.5; // 轮子直径（米）
// const kph = rpmToKph(rpm);

export const getDefaultSeriesData = () => {
  const res = {
    UIRx_FLWhlSpd_BCh1_TCS: [],
    UIRx_FRWhlSpd_BCh1_TCS: [],
    UIRx_RLWhlSpd_BCh1_TCS: [],
    UIRx_RRWhlSpd_BCh1_TCS: [],
    UIRx_VehSpd_TCS: [],
    UIRx_FLWhlSpd_BCh1_dTCS: [],
    UIRx_FRWhlSpd_BCh1_dTCS: [],
    UIRx_RLWhlSpd_BCh1_dTCS: [],
    UIRx_RRWhlSpd_BCh1_dTCS: [],
    UIRx_VehSpd_dTCS: [],
  } as DomianControl.DMCSeriesData;
  return res;
};

export const optionseries1 = () => [
  {
    id: "UIRx_VehSpd",
    name: "车速",
    color: "#e80000",
  },
  {
    id: "UIRx_FLWhlSpd_BCh1",
    name: "左前轮速",
    color: "#0372bf",
  },
  {
    id: "UIRx_FRWhlSpd_BCh1",
    name: "右前轮速",
    color: "#43a047",
  },
];
export const optionseries2 = () => [
  {
    id: "UIRx_VehSpd",
    name: "车速",
    color: "#e80000",
  },
  {
    id: "UIRx_RLWhlSpd_BCh1",
    name: "左后轮速",
    color: "#0372bf",
  },
  {
    id: "UIRx_RRWhlSpd_BCh1",
    name: "右后轮速",
    color: "#43a047",
  },
];

export const getDefaultSeriesProp = () =>
  ({
    type: "line",
    showSymbol: false,
    symbol: "circle",
    symbolSize: 6,
    lineStyle: {
      width: 2,
    },
    clip: true,
    data: [],
  } as LineSeriesOption);

export const decreasingSequence = generateNumbers(10, 0);

export const getChartsDefaultOptions = (index: number) => {
  let seriesList = [optionseries1(), optionseries2()][index] || optionseries1();
  const xAxisDate = generateNumbers(10, 0).reverse();
  const max = [80, 80][index];
  const min = [0, 0][index];

  seriesList = seriesList?.map((item: any) => ({
    ...getDefaultSeriesProp(),
    ...item,
  }));
  const lineColor = "rgba(199, 237, 250,0.2)";
  const interval = (index: number, value: string) => {
    // 判断 value 是整数
    return Number.isInteger(Number(value)) ? value : "";
  };
  return {
    backgroundColor: "#032f2b",
    animation: false,
    //   legend: {
    //     show: true,
    //     // x: "4%",
    //     top: "20px",
    //     data: ["123"],
    //     // type: "scroll",
    //     textStyle: {
    //       color: "#cccccc",
    //       fontWeight: 700,
    //       fontSize: 12,
    //     },
    //     formatter: function (name) {
    //       return name;
    //     },
    //   },
    legend: {
      show: true,
      // type: 'scroll',
      // orient: 'vertical',
      // right: 20,
      // top: "10%",
      // bottom: 20,
    },
    tooltip: {
      show: true,
      trigger: "axis",
      axisPointer: {
        type: "cross",
        label: {
          backgroundColor: "#283b56",
        },
      },
    },
    grid: {
      top: 30,
      left: 50,
      right: 50,
      bottom: 30,
    },
    xAxis: {
      name: "sec",
      data: xAxisDate,
      nameTextStyle: {
        color: "#fff",
      },
      // nameGap: -30,
      // minorTick: {
      //   show: true,
      // },
      // minorSplitLine: {
      //   show: true,
      //   lineStyle: {
      //     color: lineColor,
      //   },
      // },
      axisPointer: {
        snap: true,
        lineStyle: {
          color: "#8e96a1",
          width: 2,
        },
        label: {
          show: false,
          // formatter: function (params) {
          //   return echarts.format.formatTime('yyyy-MM-dd', params.value);
          // },
          backgroundColor: "#3fafa5",
        },
        handle: {
          show: true,
          color: "#3fafa5",
          size: 30,
          margin: 10,
          shadowOffsetX: 0,
          shadowOffsetY: 0,
          shadowBlur: 0,
        },
      },
      splitLine: {
        show: true,
        interval: (index: number, value: string) => {
          return Number.isInteger(Number(value));
        },
        lineStyle: {
          color: lineColor,
        },
      },
      axisLabel: {
        // show: index === 2 ? true : false, // 隐藏 x 轴标签
        interval,
        // formatter: (number: string) => {
        //   console.log("[BOWEN_LOG] 🚀 ~~ getChartsDefaultOptions ~~ number:", number);
        //   return Number(number) % 5 === 0 || Number(number) === 1 ? number : "";
        // },
      },
      axisTick: {
        interval,
      },
      axisLine: {
        onZero: false,
        lineStyle: {
          color: lineColor,
        },
      },
    },
    yAxis: {
      type: "value",
      name: "kph",
      nameTextStyle: {
        color: lineColor,
      },
      max,
      min,
      // minorTick: {
      //   show: true,
      // },
      minorSplitLine: {
        show: true,
        lineStyle: {
          color: lineColor,
        },
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: lineColor,
        },
      },
      axisLine: {
        lineStyle: {
          color: lineColor,
        },
      },
      // axisPointer: {
      //   type: "line",
      //   snap: true,
      //   show: true,
      //   label: {
      //     show: false,
      //     // formatter: function (params) {
      //     //   return echarts.format.formatTime('yyyy-MM-dd', params.value);
      //     // },
      //     backgroundColor: "#8e96a1",
      //   },
      // },
    },
    dataZoom: [
      {
        show: true,
        type: "inside",
        filterMode: "none",
      },
    ],
    series: seriesList,
  } as EChartsOption;
};
